import { simpleTransform } from 'sanitize-html';

import { SanitizationOption } from 'app/utils/htmlSanitizer/types';

import { SANITIZE_PROFILE_DEFAULT } from './default';
import { SANITIZE_PROFILE_EMAIL } from './email';

export const SANITIZE_PROFILE_EMAIL_SHADOW_DOM: SanitizationOption = {
  allowedTags: [
    ...(SANITIZE_PROFILE_EMAIL.allowedTags as string[]),
    // Not including <title> in the allowed tags tells the library to "santize" the tag
    // by removing the enclosing tag and leaving the content in the DOM. We add it to
    // the list of allowed tags, so that it could be removed later on by the exclusiveFilter function.
    ...['style', 'title'],
  ],
  allowedAttributes: {
    ...(SANITIZE_PROFILE_EMAIL.allowedAttributes as Record<string, string[]>),
    font: ['face'],
  },
  allowedSchemes: SANITIZE_PROFILE_DEFAULT.allowedSchemes,
  transformTags: {
    // Links should open in a new tab.
    a: simpleTransform('a', { target: '_blank', rel: 'noopener noreferrer' }),
  },
  exclusiveFilter: (element) => {
    return (
      SANITIZE_PROFILE_EMAIL.exclusiveFilter?.(element) ||
      // Remove the title tag along with its text content.
      element.tag === 'title'
    );
  },
  // To suppress the warning about including style tags in the allowedTags
  allowVulnerableTags: true,
};
